module.exports = __webpack_public_path__ + "img/john.14b71f6e.jpg";